import { render, staticRenderFns } from "./AddExpert.vue?vue&type=template&id=5c9d3a4f&scoped=true"
import script from "./AddExpert.vue?vue&type=script&lang=js"
export * from "./AddExpert.vue?vue&type=script&lang=js"
import style0 from "./AddExpert.vue?vue&type=style&index=0&id=5c9d3a4f&prod&lang=scss&scoped=true"
import style1 from "./AddExpert.vue?vue&type=style&index=1&id=5c9d3a4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9d3a4f",
  null
  
)

export default component.exports